<template>
	<div v-if="loading">
		<div class="loader"></div>
	</div>
	<div v-else-if="certificates && Object.keys(certificates).length > 0" class="headed-table headed-table--sticky-labels">
		<table>
            <thead>
                <tr>
                    <th>
                        <small v-if="is_job" >Staff on Job</small>
                        <small v-else >Staff in Company</small>
                    </th>
                    <th v-for="(header, index) in training_certificate_types" :key="index">
                        <small>{{ header }}</small>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr  v-for="(user, rowIndex) in certificates" :key="rowIndex">
                    <td>
                        <a :href="generateRouteUser(user.id)" class="people-list--item-title" target="_blank">
                            <h5 class="people-list--item-title-name">{{user.full_name}}</h5>
                            <h6 class="people-list--item-title-email">{{user.email}}</h6>
                        </a>
                    </td>
                    <td class="col-3" v-for="(cell, certificateIndex) in training_certificate_types" :key="certificateIndex">
                        <div class="d-flex justify-content-center">
                            <template v-for="(items) in user.certificates.has_certificates">
                                <template v-if="items.training_certificate_type_id == certificateIndex">
                                    <a class="btn" v-if="items.formatted_expiry_date !== null && items.has_expired === 'expiring'"  :href="generateRouteSubmission(items.job_id, items.form_submission_id)" target="_blank" :key="`${items.training_certificate_type_id}_expired`">
                                        <div class="badge badge--sm badge--tolerable">
                                            {{items.formatted_expiry_date }}
                                        </div>
                                    </a>
                                    <a class="btn" v-else-if="items.formatted_expiry_date !== null" :href="generateRouteSubmission(items.job_id, items.form_submission_id)" target="_blank" :key="items.training_certificate_type_id">
                                        <div class="badge badge--sm" :class="items.has_expired == true ? 'badge--negative' : 'badge--positive'">
                                            {{items.formatted_expiry_date }}
                                        </div>
                                    </a>
                                    <div v-if="items.formatted_expiry_date === null" class="badge badge--sm badge--primary" :key="items.training_certificate_type_id">
                                        No expiry
                                    </div>
                                </template>
                            </template>
                            <template v-if="user.certificates.other_certificates">
                                <p>{{items}}</p>
                                <div 
                                    v-if="user.certificates.other_certificates.training_certificate_type_id == certificateIndex
                                        && user.certificates.other_certificates.total > 0" 
                                    class="badge badge--sm badge--primary"
                                >
                                    <span v-if="user.certificates.other_certificates.expired > 0" >
                                        Expired: {{ user.certificates.other_certificates.expired }}
                                    </span>
                                    <span v-if="user.certificates.other_certificates.expired > 0 && user.certificates.other_certificates.valid > 0 ">,&nbsp;</span>
                                    <span v-if="user.certificates.other_certificates.valid > 0 ">
                                        Valid: {{ user.certificates.other_certificates.valid }}
                                    </span>
                                </div>
                            </template>
                        </div>
                    </td>
                </tr>
            </tbody>
		</table>
	</div>
	<div v-else class="headed-table no-results d-flex justify-content-center">
		<div class="text-center">
			<h5 class="m-4 mx-auto text-dark">No staff assigned to job</h5>
		</div>
    </div>

</template>

<script>
    import generateRoute, { generateRouteWithMultipleParameters } from "../../helpers/routes";
	export default {
		name: "CertificateComponent",
		data() {
			return {
                items: null,
			};
		},
		props: {
			loading:true,
			certificates:{},
			training_certificate_types:{},
            is_job: null,
            show_user_url: '',
            show_submission_url: '',
        },
        methods: {
            generateRouteSubmission(job, submission) {
                return generateRouteWithMultipleParameters(this._props.show_submission_url, {'job?': job, 'submission?': submission});
            },
            generateRouteUser(userId) {
                return generateRoute(this._props.show_user_url, userId);
            },
        }
	}
</script>

<style lang="scss" scoped>
.no-results {
	overflow-x: auto !important;
	overflow-y: auto !important;
}
</style>
